module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0144.jpg?v=543ed702";